import { render, staticRenderFns } from "./BidDetails.vue?vue&type=template&id=32a10749&scoped=true&"
import script from "./BidDetails.vue?vue&type=script&lang=js&"
export * from "./BidDetails.vue?vue&type=script&lang=js&"
import style0 from "./BidDetails.vue?vue&type=style&index=0&id=32a10749&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a10749",
  null
  
)

export default component.exports